import React, { useState, useEffect,useCallback } from 'react';
import { Card, Button, Form, message,Row, Col } from 'antd';
import Loading from './../../../Loading';
import styles from './../index.module.css';
import PageContainer from '../../../CSIComponents/PageContainer';
import GeneralView from './Views/WaterUsageView';
import GeneralEdit from './Views/WaterUsageEdit';
import { postHelper,getHelper } from '../../../Categories/helper';
import {WaterUsageType,EnvironmentalImpact} from './WaterUsageInterface/WaterUsageInterface';
import ActionButtonsBar from '../../../ui/ActionButtonsBar/ActionButtonsBar';


interface propsTypes {
  isEditable: () => void,
  cancelEditable: () => void,
  disableTabPanes: (val:boolean) => void,
}

interface WaterUsage {
  supplier: string;
  propertyId: string;
  property: {
      environmentalimpact: object
  };
}

let response: any = {};
const WaterUsage = (props: propsTypes) => {

  const [form] = Form.useForm();
  const [viewOrEdit, setViewOrEdit] = useState(1);
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [editData, setEditData] = useState<EnvironmentalImpact | null>(null);
  const [generalObj, setGeneralObj] = useState<object | null>(null)
  const [disableFlag, setDisableFlag] = useState(false)
  const [waterListEdited,setWaterListEdited] = useState(false)
  const [panes, setPanes] = useState([])

  const afterUpdate = () => {
    props.cancelEditable();
    props.disableTabPanes(false)
    setViewOrEdit(1)
    setEditData(null)
    setLoadingFlag(false)
    setWaterListEdited(false)
    getEnvImpactsData()
  }

  const onFinish = () => {
    form.validateFields().then(async formData => {
      const sortPaneList = panes.filter(({ desc }) => desc !== '')
      setLoadingFlag(true)
      const waterUsagePayload = {
        supplier: response?.property?.supplier,
        propertyId: response?.property?.propertyId,
        property: {
          environmentalimpact: {
            id: response?.property?.environmentalimpact?.id,
            langid: response?.property?.environmentalimpact?.langid,
            waterusage: {
              greywaterecycling: formData.greywaterecycling || '',
              waterconservation: formData.waterconservation || '',
              waterdiversion: +formData.waterdiversion || '',
              perroomnightperiod: +formData.perroomnightperiod || '',
              perroomdayperiod: +formData.perroomdayperiod || '',
              perroomday: formData.perroomday || '',
              perroomnight: formData.perroomnight || '',
              waterdiversionrateperiod: +formData.waterdiversionrateperiod || '',
              uom: formData.uom || '',
              description: sortPaneList
            }
          }
        }
      }

      try{
        await postHelper('/property/env/waterusage', waterUsagePayload)
        afterUpdate()
      }
      catch(err: any){
        message.error({
          content: err?.message || err[0]?.error[0]?.message || err[1]?.error[0]?.message || err[2]?.error[0]?.message
        });
        afterUpdate()
      }

    })
      .catch(() => {
        message.error({
          content: 'Check all the fields please.',
        });
      });
  };

  const cancelClik = () => {
    props.cancelEditable();
    props.disableTabPanes(false)
    setWaterListEdited(false)
    setViewOrEdit(1)
  }

  const handleSuccessData = (data: WaterUsageType) => {
    if (data?.property?.environmentalimpact) {
      setEditData(data?.property);
      form.resetFields()

    const WaterUsageDescription = data?.property?.environmentalimpact?.waterusage?.description || [];
    let waterUsageEditData: { desc?: string } = {}
    WaterUsageDescription.forEach((item: { desc?: string}, i: number) => {
      waterUsageEditData[`desc-${i}`] = item.desc
    });
    setGeneralObj({
      ...data?.property?.environmentalimpact?.waterusage,
      ...waterUsageEditData
     })
    }
  }

  const getEnvImpactsData = useCallback(async () => {

      try{
        const data: WaterUsageType = await getHelper('/property/environmentalimpact')
        if(data?.property?.environmentalimpact){
          response = data
          handleSuccessData(data)
        } else{
          response = {}
          setEditData({})
          setGeneralObj({})
        }
        handleSuccessData(data)
        form.validateFields().then(() => {
          setDisableFlag(false)
        }).catch(err => {
          err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
        });
      }
      catch(err: any){
        message.error({
          content: err?.message || err?.error[0]?.message
        });
        response = {}
        setEditData({})
        setGeneralObj({})
      }
  },[])


  const handleEdit =()=>{
    setViewOrEdit(2); 
    props.disableTabPanes(true); 
    form.setFieldsValue(generalObj) 
  }


  useEffect(() => {
    getEnvImpactsData()
  },[])
  const editButton = (
    <>
      <Button type="primary" className="db-edit-btn" onClick={handleEdit}>Edit</Button>
    </>
  )
  return (
    <PageContainer>
      <Card style={{ marginTop: -15, marginBottom: 70 }}>
        {editData ? generalObj && 
          <Form
            form={form}
            layout="vertical"
            onValuesChange={() => {
              form.validateFields().then(() => {
                setDisableFlag(false)
              }).catch(err => {
                err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
              })
            }}
          >
            <Row style={{ marginBottom: '32px' }} justify="space-between">
                <Col style={{fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px'}} span={12}>Water Usage</Col>
                {viewOrEdit === 1 && (<Col style={{textAlign: "right"}} span={12}>{editButton}</Col>)}
            </Row>
            {
              viewOrEdit === 1 ?
                <GeneralView dataList={editData} />
                :
                <GeneralEdit
                  setWaterListEdited={setWaterListEdited}
                  dataList={editData}
                  currentForm={form}
                  panesData={setPanes}
                />}
          </Form>
          : <>
            <div style={{ marginBottom: '50vh' }}><Loading type='large' /></div>
          </>
        }
      </Card>
                <ActionButtonsBar
                  onCancel={cancelClik}
                  onSave={onFinish}
                  disabledSave={disableFlag}
                  show={viewOrEdit !== 1}
                />
      {
        loadingFlag && <div className={styles['loading-wrap']}><Loading type="large" /></div>
      }
    </PageContainer>
  )
}


export default WaterUsage;
